import React, { FC } from 'react'

import { Text, TextName } from 'sdk'

import { HomeAccelerationCmsContent } from 'core/services/cms/interfaces'

import { AccelerationCards } from '../../components/acceleration-cards/AccelerationCards'

import classes from './style.module.scss'

interface AccelerationSectionProps {
  content: HomeAccelerationCmsContent
}

export const AccelerationSection: FC<AccelerationSectionProps> = ({ content }) => {
  return (
    <div className={classes.container}>
      <Text type={TextName.H2} className={classes.title}>
        {content.title}
      </Text>

      <AccelerationCards cards={content.cards} />
    </div>
  )
}
